import { api } from '../lib/api.js';

// GET /api/me/open-items — ראה server/src/modules/me/open-items.service.ts.
export type OpenItem = {
  kind: 'QUESTION' | 'TASK';
  id: string;
  title: string;
  text: string | null;
  from: string | null;
  projectNumber: string | null;
  ref: string | null;
  at: string;
  dueDate: string | null;
  overdue: boolean;
  href: string;
  canReply: boolean;
  canDone: boolean;
  /** תחנה שדולגה ב„הורכב" — „מלא שעות" / „התחנה לא רלוונטית" בחלון עצמו. */
  /** `review` — שעות שמולאו בקיוסק ההרכבה בשם אחר: „אשר" / „שנה" במקום מילוי. */
  gap?: { partId: string; partNumber: string; sequenceIndex: number; stageName: string; quantity: number; review?: import('./productionBoard.js').GapReview };
  /** ההסבר המלא — tooltip על השורה. */
  hint?: string;
};
export type OpenItems = { items: OpenItem[]; questions: number; tasks: number };

export const OPEN_ITEMS_KEY = ['me-open-items'] as const;

export const openItemsApi = {
  mine: () => api<OpenItems>('/api/me/open-items'),
};

// „פעם אחת בכל כניסה": הדגל יושב ב-sessionStorage, ונמחק ביציאה — כך כניסה
// הבאה באותה לשונית מציגה שוב את מה שעוד פתוח. חסום (גלישה פרטית) = מוצג שוב, לא נשבר.
const SHOWN_PREFIX = 'edal.openItems.shown:';
export function openItemsShown(userId: string): boolean {
  try { return sessionStorage.getItem(SHOWN_PREFIX + userId) === '1'; } catch { return false; }
}
export function markOpenItemsShown(userId: string): void {
  try { sessionStorage.setItem(SHOWN_PREFIX + userId, '1'); } catch { /* אין אחסון — לא נורא */ }
}
export function clearOpenItemsShown(): void {
  try {
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const k = sessionStorage.key(i);
      if (k?.startsWith(SHOWN_PREFIX)) sessionStorage.removeItem(k);
    }
  } catch { /* אין אחסון */ }
}

/** מזהה הפריט מתוך קישור ההתראה: `/app/tasks?task=…` או `/app/questions?q=…`. */
export function itemIdFromLink(link: string | null): string | null {
  if (!link) return null;
  const m = /[?&](?:task|q)=([^&#]+)/.exec(link);
  if (!m) return null;
  try { return decodeURIComponent(m[1]!); } catch { return null; }
}
